import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useQuery, useMutation } from '@grandvisionhq/graphql';
import { toBillingAddress } from '../mappers/profile.js';
import UPDATE_BILLING_ADDRESS from '../operations/mutations/update-billing-address.js';
import GET_BILLING_ADDRESS from '../operations/queries/get-billing-address.js';

const useBillingAddress = ({ onError , onCompleted  } = {})=>{
    var ref3, ref1;
    const setOptions = React.useCallback((reason)=>{
        return {
            onError: (error)=>{
                onError === null || onError === void 0 ? void 0 : onError({
                    reason,
                    error
                });
            },
            onCompleted: (data)=>{
                onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted({
                    reason,
                    data
                });
            },
            // Currently the BE response does not resolve fast enough so we have to temporarily
            // increase the timeout that is configured globally in graphql/src/apollo/client.ts.
            // When the backend performance has been improved, we will remove this and revert
            // to the global config of 10s.
            context: {
                timeout: 20000
            }
        };
    }, [
        onCompleted,
        onError
    ]);
    /**
   * GQL query for retrieving billing address
   */ const queryOptions = React.useMemo(()=>setOptions('QUERY')
    , [
        setOptions
    ]);
    const query = useQuery(GET_BILLING_ADDRESS, queryOptions);
    /**
   * GQL mutation for updating billing address
   */ const mutationOptions = React.useMemo(()=>setOptions('MUTATION')
    , [
        setOptions
    ]);
    const [mutationCallback, mutation] = useMutation(UPDATE_BILLING_ADDRESS, swcHelpers.objectSpread({}, mutationOptions, {
        refetchQueries: [
            {
                query: GET_BILLING_ADDRESS
            }
        ]
    }));
    return React.useMemo(()=>{
        var ref, ref2;
        return {
            billingAddressData: toBillingAddress((ref = query.data) === null || ref === void 0 ? void 0 : (ref2 = ref.me) === null || ref2 === void 0 ? void 0 : ref2.defaultBillingAddress),
            updateBillingAddress: function() {
                var _ref = swcHelpers.asyncToGenerator(function*(billingAddress, userId) {
                    yield mutationCallback({
                        variables: {
                            customerId: userId,
                            input: billingAddress
                        }
                    });
                });
                return function(billingAddress, userId) {
                    return _ref.apply(this, arguments);
                };
            }(),
            isFetching: query.loading,
            fetchError: query.error,
            isUpdating: mutation.loading
        };
    }, [
        mutation.loading,
        mutationCallback,
        (ref3 = query.data) === null || ref3 === void 0 ? void 0 : (ref1 = ref3.me) === null || ref1 === void 0 ? void 0 : ref1.defaultBillingAddress,
        query.error,
        query.loading, 
    ]);
};

export { useBillingAddress };
//# sourceMappingURL=use-billing-address.js.map
